export class CarouselComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/carousel/carousel.html';
  public controllerAs: string = '$ctrl';
  public transclude: boolean = true;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/carousel/carousel.ts